import type { SYSTableDefIds } from "../../../../../../../../_ovlclient/src"
import { html, SYSBaseElement } from "../../../../../../../../_ovlclient/src"
import {
  getRequest,
  postRequest,
} from "../../../../../../../../_ovlclient/src/effects"
import { N, N0, T } from "../../../../../../../../_ovlclient/src/textapi"

import {
  FeatureInfo,
  FileGet,
} from "../../../../../../../../_ovlclient/src/global/globalapi"
import {
  DialogOk,
  DialogOkCancel,
  DialogOpen,
} from "../../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import {
  ProcessEnd,
  ProcessIsRunning,
  ProcessStart,
} from "../../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import {
  ScreenCurrentState,
  ScreenNavigateBack,
} from "../../../../../../../../_ovlclient/src/library/screenapi"
import {
  TableFormEditRow,
  TableGet,
} from "../../../../../../../../_ovlclient/src/library/table/tableapi"
import {
  Costs,
  Material,
  Transport,
} from "../../../../features/qutoffering/offering/details/tabledefs"
import { OfferingTool } from "../../../../features/qutoffering/offering/state"
import { Offering } from "../../../../features/qutoffering/offering/tabledef"
import {
  BrowseOfferFile,
  EditLocked,
  GetDeliveryTimeHint,
  OfferingMainRefresh,
  OpenTableUploadEdit,
} from "../helpers"

import { Data } from "../../../../../../../../_ovlclient/src/dataapi"
import { FormInit } from "../../../../../../../../_ovlclient/src/library/forms/formapi"
import { SnackAdd } from "../../../../../../../../_ovlclient/src/library/snackapi"

export class ScreenOfferingDetails extends SYSBaseElement {
  browseFileEl: HTMLInputElement
  offeringToolState: OfferingTool
  selectedOffer: Offering
  imageLoading: boolean
  hasErrors: boolean
  async init() {
    this.offeringToolState = this.state.app.features.QUTOffering
    this.selectedOffer =
      this.state.app.global.QUT.tables.QUTOffering.data[
        ScreenCurrentState().instance
      ]
    await super.init()
  }
  handleImagePopup(e: Event) {
    this.state.app.features.GENImagePopup.imagePopup =
      this.offeringToolState.imageLoaded
    DialogOpen("GENImagePopup")
  }
  async handleReupload(e: Event) {
    e.preventDefault()
    e.stopPropagation()
    //@ts-ignore
    if (e.target.files.length > 0) {
      this.selectedOffer.U_ITF_PRT_OfferStatus = "Init"
      //@ts-ignore
      await this.actions.app.screens.QUTOfferingDetails.actions.Reupload({
        offeringToolState: this.offeringToolState,
        //@ts-ignore
        file: e.target.files[0],
      })
    }
  }

  async handlePDFClick(e: Event) {
    e.preventDefault()
    e.stopPropagation()
    let docEntry =
      this.state.app.global.QUT.tables.QUTOffering.data[
        this.offeringToolState.selectedOfferKey
      ]["DocEntry"]
    await FileGet({
      cat: "OfferingToolPDF",
      id1: docEntry,
    })
  }

  async handleAcceptedClick(e: Event) {
    e.preventDefault()
    e.stopPropagation()

    let docEntry =
      this.state.app.global.QUT.tables.QUTOffering.data[
        this.offeringToolState.selectedOfferKey
      ]["DocEntry"]

    if (
      (await DialogOkCancel(T("QUTOfferingOfferingAcceptOfferDialog"))) === 2
    ) {
      return
    }

    try {
      ProcessStart("QUTOfferingOfferingAcceptOfferSnack")
      await getRequest(`${this.state.ovl.apiUrl}offering/acceptoffer`, {
        id: docEntry,
      })
      await ScreenNavigateBack()
      this.offeringToolState.selectedOfferKey = undefined
      OfferingMainRefresh(this.state)
    } finally {
      ProcessEnd("QUTOfferingOfferingAcceptOfferSnack")
    }
  }

  handleDeliveryWeekClick(e: Event) {
    e.preventDefault()
    e.stopPropagation()
    TableFormEditRow(
      <SYSTableDefIds>(
        ("QUTOffering" +
          (this.state.app.features.QUTOffering.selectedOfferType === "Actual"
            ? "Actual"
            : ""))
      ),
      this.state.app.features.QUTOffering.selectedOfferKey
    )
  }
  async handleRecalcClick(e: Event) {
    e.preventDefault()
    e.stopPropagation()
    let materialRes
    let transportRes

    if (this.offeringToolState.detailsMaterialChanged) {
      let materialDef = TableGet<Material>("QUTOfferingMaterial")
      let materialKeys = materialDef.getKeys()
      let material = materialDef.rows
      materialRes = materialKeys.reduce((val, k) => {
        if (material[k].Price === undefined) {
          let catKey = material[k].ItemCode.substring(0, 3)
          if (!val[catKey]) {
            val[catKey] = []
          }
          if (val[catKey].indexOf(material[k].Skl) < 0) {
            val[catKey].push(material[k].Skl)
          }
        }
        return val
      }, {})
    }
    if (this.offeringToolState.detailsTransportChanged) {
      let transportDef = TableGet<Transport>("QUTOfferingTransport")
      let transportKeys = transportDef.getKeys()
      let transport = transportDef.rows
      transportRes = {
        transportType: transport[transportKeys[0]].TransportType,
        zipCode: transport[transportKeys[0]].ZipCode,
        city: transport[transportKeys[0]].City,
        street: transport[transportKeys[0]].Street,
      }
    }
    let costDef = TableGet<Costs>("QUTOfferingCosts", {
      byKeys: "StaticFiltered",
    })
    let costData = costDef.rows
    let manualSurchargeItems = []
    let materialTreatmentItems = []
    costDef.getKeys().forEach((f) => {
      if (costData[f].ItemType === "ManualSurcharge") {
        manualSurchargeItems.push({
          itemCode: costData[f].ItemCode,
          lineTotal: costData[f].CostCost,
          description: costData[f].CostDescription,
        })
      } else if (costData[f].ItemType === "MaterialTreatment") {
        materialTreatmentItems.push({
          itemCode: costData[f].ItemCode,
          quantity: costData[f].Quantity,
        })
      }
    })

    let docEntry =
      this.state.app.global.QUT.tables.QUTOffering.data[
        this.offeringToolState.selectedOfferKey
      ]["DocEntry"]
    let postData = {
      docEntry,
      recalc: {
        material: materialRes,
        transport: transportRes,
        materialTreatmentItems,
        manualSurchargeItems,
        cutPositionsChanged: this.offeringToolState.cutPositionsChanged,
      },
    }

    await this.actions.app.features.QUTOffering.actions.ShowOfferingProgress({
      docEntry,
      clearError: false,
      setStatus: "Calculating",
      snackKey: "QUTOfferingRecalcStatus",
    })
    await postRequest(`${this.state.ovl.apiUrl}offering/recalc`, postData)
    //await OfferingDetailsRefresh(this.state, this.actions, true)
  }

  async firstUpdated() {
    if (this.hasErrors) {
      DialogOk(
        "Error 75: Totals not consistent (Check Item Masterdata Attributes)",
        { type: "error" }
      )
    }
  }
  async getUI() {
    if (this.selectedOffer.U_ITF_PRT_OfferError) {
      ScreenNavigateBack()
      return null
    }
    let editable =
      this.selectedOffer.U_ITF_PRT_OfferStatus === "Ready" ||
      (FeatureInfo("QUTOfferingToolAdmin") &&
        this.selectedOffer.U_ITF_PRT_OfferStatus === "Accepted")

    let editLocked = EditLocked()

    let costs = this.state.app.global.QUT.tables.QUTOfferingCosts
    let costsData = costs.data
    let costsDef = costs.tableDef.QUTOfferingCosts
    let costsTotalNum = 0
    let costsTotal = "---"
    if (
      !this.state.app.features.QUTOffering.detailsMaterialChanged &&
      !this.state.app.features.QUTOffering.cutPositionsChanged &&
      !this.state.app.features.QUTOffering.detailsCostChanged
    ) {
      costsTotalNum = costsDef.uiState.dataFilteredAndSorted.reduce(
        (val, k) => {
          val += costsData[k]["CostCost"]
          return val
        },
        0
      )
      costsTotal = N(costsTotalNum)
    }

    let transport = this.state.app.global.QUT.tables.QUTOfferingTransport
    let transportData = transport.data
    let transportDef = transport.tableDef.QUTOfferingTransport
    let transportTotal = "---"
    let transportTotalNum = 0
    if (
      !this.state.app.features.QUTOffering.detailsTransportChanged &&
      !this.state.app.features.QUTOffering.detailsMaterialChanged &&
      !this.state.app.features.QUTOffering.cutPositionsChanged
    ) {
      transportTotalNum = transportDef.uiState.dataFilteredAndSorted.reduce(
        (val, k) => {
          val += transportData[k]["TransportCost"]
          return val
        },
        0
      )
      transportTotal = N(transportTotalNum)
    }

    let material = this.state.app.global.QUT.tables.QUTOfferingMaterial
    let materialData = material.data
    let materialDef = material.tableDef.QUTOfferingMaterial
    let materialTotal = "---"
    let materialTotalNum = 0
    if (
      !this.state.app.features.QUTOffering.detailsMaterialChanged &&
      !this.state.app.features.QUTOffering.cutPositionsChanged
    ) {
      materialTotalNum = materialDef.uiState.dataFilteredAndSorted.reduce(
        (val, k) => {
          val += materialData[k]["LineTotal"]
          return val
        },
        0
      )
      materialTotal = N(materialTotalNum)
    }
    let total = "---"
    let totalNum = 0
    if (
      !this.state.app.features.QUTOffering.detailsChanged &&
      materialTotal !== "---" &&
      transportTotal !== "---" &&
      costsTotal != "---"
    ) {
      totalNum = this.selectedOffer.DocTotal
      total = N0(totalNum)
    }
    this.selectedOffer.DocTotal
    if (
      total !== "---" &&
      Math.abs(
        materialTotalNum + transportTotalNum + costsTotalNum - totalNum
      ) > 1
    ) {
      materialTotal = "---"
      costsTotal = "---"
      transportTotal = "---"
      this.hasErrors = true
    }

    let deliveryTimeHintDesc

    if (!EditLocked()) {
      deliveryTimeHintDesc = html` <a
        href=""
        id="deliveryTime"
        @click=${(e) => this.handleDeliveryWeekClick(e)}
        >${T("QUTOfferingOfferingDeliveryTimeHint")}
      </a>`
    }
    let deliveryTimeHintValue = GetDeliveryTimeHint(
      this.state,
      this.selectedOffer.U_COR_LI_1
    ).res

    let img
    if (
      this.offeringToolState.imageLoaded &&
      this.selectedOffer.U_ITF_PRT_OfferStatus !== "Init" &&
      this.selectedOffer.U_ITF_PRT_OfferStatus !== "SubmittedToCadwork"
    ) {
      img = html`<img
        id="offering-details-img"
        src="${this.offeringToolState.imageLoaded}"
        @click=${(e) => this.handleImagePopup(e)}
      />`
    } else if (
      this.selectedOffer.U_ITF_PRT_OfferMainType === "CAD" &&
      this.selectedOffer.U_ITF_PRT_FileName &&
      this.selectedOffer.U_ITF_PRT_FileName.endsWith(".3d")
    ) {
      img = html` <div
        class="fd-busy-indicator--s"
        aria-hidden="false"
        aria-label="Loading"
      >
        <div class="fd-busy-indicator--circle-0"></div>
        <div class="fd-busy-indicator--circle-1"></div>
        <div class="fd-busy-indicator--circle-2"></div>
      </div>`
    } else {
      img = null
    }

    let adminOfferInfo

    if (FeatureInfo("QUTOfferingToolAdmin")) {
      let cadOfferType
      if (this.offeringToolState.offerMainType === "CAD") {
        cadOfferType = html` <div>
          ${T("QUTOfferingColOfferingAdminOfferType")}:
          ${this.selectedOffer.U_ITF_PRT_OfferType === "Target"
            ? "Soll"
            : "Ist"}
        </div>`
      }
      adminOfferInfo = html`<p class="fd-layout-panel__description">
         <div> ${T("QUTOfferingColOfferingCntctName")}: ${
           this.selectedOffer.CntctName
         }
        </div>
${cadOfferType}</p> `
    }

    let reuploadOrNewPositionsButton
    if (this.selectedOffer.U_ITF_PRT_OfferMainType === "CAD") {
      reuploadOrNewPositionsButton = html`
        <div>
          <button
            class="fd-button offering-details-actionbutton"
            ?disabled=${this.offeringToolState.detailsChanged !== undefined ||
            !editable ||
            editLocked}
            @click=${async () => {
              if (FeatureInfo("QUTOfferingToolAdmin")) {
                let docEntry =
                  TableGet("QUTOffering").rows[
                    this.offeringToolState.selectedOfferKey
                  ]["DocEntry"]
                this.state.app.features.QUTOffering.adminResumeDocEntry =
                  docEntry
                await OpenTableUploadEdit()
              } else {
                BrowseOfferFile()
              }
            }}
          >
            <span class="fd-button__text"
              >${T("QUTOfferingOfferingDetailsActionReupload")}</span
            >
            <i class="sap-icon--upload"></i>
          </button>
          <div
            class="fd-file-uploader__hidden"
            aria-live="polite"
            aria-atomic="true"
          ></div>
          <input
            id="offering-newfile"
            class="fd-file-uploader__hidden"
            @input=${async (e) => await this.handleReupload(e)}
            type="file"
          />
        </div>
      `
    } else {
      reuploadOrNewPositionsButton = html`
        <button
          class="fd-button offering-details-actionbutton"
          id="qutofferingposopen"
          ?disabled=${!editable || editLocked}
          @click=${async () => {
            let tb = TableGet("QUTOfferingPos")
            // if opened from here its always a new table
            // still we need to contact server for the schema
            await tb.refresh({
              resetStrategy: { ClearData: true },
              forcedFilters: {
                staticFilter: { U_DocEntry: this.selectedOffer.DocEntry },
              },
            })
            await FormInit(
              "SYSEdit",
              {
                SYSEdit_Commission: {
                  value: this.selectedOffer.Comments,
                  type: "text",
                  schema: { nullable: false },
                  ui: { labelTranslationKey: "GENCommission" },
                },
              },
              {
                feature: "QUTOfferingPos",
                formId: "QUTOfferingPos",
                forceOverwrite: true,
              }
            )
            this.state.app.features.QUTOffering.cutListDirty = false
            this.state.app.features.QUTOffering.cutFileName = ""
            DialogOpen("QUTOfferingPos")
          }}
        >
          <span class="fd-button__text">${T("QUTOfferingPosOpenPos")}</span>
          <i class="sap-icon--along-stacked-chart"></i>
        </button>
      `
    }
    return html`
      <div class="fd-layout-panel ">
        <div class="fd-layout-panel__header">
          <div class="fd-layout-panel__head">
            <h2>
              ${T("QUTOfferingOfferingDetails", [
                this.selectedOffer.DocEntry,
                this.selectedOffer.Comments,
              ])}
            </h2>

            ${adminOfferInfo}
          </div>
        </div>

        <div class="fd-layout-panel__body">
          <div class="offering-details">
            <div class="offering-details-costs">
              <div class="fd-margin--tiny">
                <h4>
                  ${T("QUTOfferingOfferingProductionAndServices")}
                </h4>
                <ovl-table
                  class="fd-table offeringcosts-table fd-table--condensed"
                  .props=${() => <SYSTableDefIds>"QUTOfferingCosts"}
                >
                </ovl-table>
              </div>
            </div>
            <div class="offering-details-costs-total">
              <div class="offering-details-total">
                <div class="sap-icon sap-icon--settings"></div>
                <div>CHF ${costsTotal}</div>
              </div>
            </div>
            <div class="offering-details-transport">
              <div class="fd-margin--tiny">
                <h4 class="fd-margin--tiny">
                  ${T("QUTOfferingOfferingTransport")}
                </h4>
                <div>
                  <span class="offeringduedatelink">
                    ${deliveryTimeHintDesc} ${deliveryTimeHintValue}
                  </span>
                </div>
                <ovl-table
                  class="fd-table offeringtransport-table fd-table--condensed"
                  .props=${() => <SYSTableDefIds>"QUTOfferingTransport"}
                >
                </ovl-table>
              </div>
            </div>
            <div class="offering-details-transport-total">
              <div class="offering-details-total">
                <div class="sap-icon sap-icon--inventory"></div>
                <div>CHF ${transportTotal}</div>
              </div>
            </div>
            <div class="offering-details-material">
              <div class="fd-margin--tiny">
                <h4 class="fd-margin--tiny">
                  ${T("QUTOfferingOfferingMaterial")}
                </h4>
                <ovl-table
                  class="fd-table offeringcosts-table fd-table--condensed"
                  .props=${() => <SYSTableDefIds>"QUTOfferingMaterial"}
                >
                </ovl-table>
              </div>
            </div>
            <div class="offering-details-material-total">
              <div class="offering-details-total">
                <div class="sap-icon sap-icon--along-stacked-chart"></div>
                <div>CHF ${materialTotal}</div>
              </div>
            </div>
            <div class="offering-details-picture">${img}</div>
            <div class="offering-details-actions">
              <div class="offering-total">
                <div>${T("QUTOfferingOfferingTotal", [total])}</div>
              </div>
              <div>
                <button
                  class="fd-button fd-button--attention is-selected offering-details-actionbutton"
                  ?disabled=${!this.offeringToolState.detailsChanged ||
                  ProcessIsRunning("GENNewOfferUpload") ||
                  !editable ||
                  editLocked}
                  @click=${async (e) => await this.handleRecalcClick(e)}
                >
                  <span class="fd-button__text"
                    >${T("QUTOfferingOfferingDetailsActionRecalc")}</span
                  >
                  <i class="sap-icon--refresh"></i>
                </button>
              </div>
              ${reuploadOrNewPositionsButton}
              <div>
                <button
                  class="fd-button offering-details-actionbutton"
                  ?disabled=${this.offeringToolState.detailsChanged !==
                    undefined ||
                  ProcessIsRunning("GENNewOfferUpload") ||
                  !editable ||
                  ProcessIsRunning("QUTOfferingOfferingPDFDownloading")}
                  @click=${(e) => this.handlePDFClick(e)}
                >
                  <span class="fd-button__text"
                    >${T("QUTOfferingOfferingDetailsActionPDF")}</span
                  >
                  <i class="sap-icon--pdf-attachment"></i>
                </button>
              </div>
              <div>
                <button
                  class="fd-button fd-button--positive offering-details-actionbutton"
                  ?disabled=${this.offeringToolState.detailsChanged !==
                    undefined ||
                  ProcessIsRunning("GENNewOfferUpload") ||
                  !editable ||
                  this.selectedOffer.U_ITF_PRT_OfferStatus === "Accepted"}
                  @click=${(e) => this.handleAcceptedClick(e)}
                >
                  <span class="fd-button__text"
                    >${T("QUTOfferingOfferingDetailsActionAccept")}</span
                  >
                  <i class="sap-icon--accept"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  }
  async getImage() {
    if (
      !this.offeringToolState.imageLoaded &&
      this.selectedOffer.U_ITF_PRT_FileName &&
      this.selectedOffer.U_ITF_PRT_FileName.endsWith(".3d") &&
      this.selectedOffer.U_ITF_PRT_OfferStatus !== "Init" &&
      this.selectedOffer.U_ITF_PRT_OfferStatus !== "SubmittedToCadwork"
    ) {
      let params = {
        cat: "OfferingToolDetailPic",
        id1: this.selectedOffer.DocEntry,
      }
      let res
      this.imageLoading = true
      try {
        res = await Data("assets/download", params, {
          expectBlob: true,
          method: "GET",
        })
        const urlCreator = window.URL || window.webkitURL
        this.offeringToolState.imageLoaded = urlCreator.createObjectURL(
          res.data
        )
      } catch {
        this.offeringToolState.imageLoaded = "none"
      } finally {
        this.imageLoading = false
      }
    }
  }
  async updated() {
    if (!this.imageLoading) {
      this.getImage()
    }
  }
}
